import { Link, useSearchParams } from 'react-router-dom'
import { Layers, Plus } from 'lucide-react'
import { Button } from '@orisini/ui/components/button'
import { cn } from '@orisini/ui/lib/utils'
import QueuePanel from '@/features/queue/components/QueuePanel'
import PublishedPanel from '../components/PublishedPanel'

const TABS = [
  ['queue', 'Queue'],
  ['published', 'Published'],
] as const

type Tab = (typeof TABS)[number][0]

/**
 * Halaman Pin: antrean dan pin yang sudah terbit, dalam satu tempat.
 *
 * Tab disimpan di query string, bukan state lokal, supaya tautan ke tab Terbit
 * bisa dibagikan dan refresh tidak melempar balik ke antrean. Nilai apa pun
 * selain "published" jatuh ke antrean — itu tab defaultnya.
 */
export default function PinsPage() {
  const [params, setParams] = useSearchParams()
  const tab: Tab = params.get('tab') === 'published' ? 'published' : 'queue'

  function pilih(next: Tab) {
    // `replace` supaya berpindah tab tidak menumpuk riwayat browser.
    setParams(next === 'queue' ? {} : { tab: next }, { replace: true })
  }

  return (
    <div className="space-y-6">
      <header className="flex flex-wrap items-center justify-between gap-4">
        <h1 className="text-2xl font-semibold tracking-tight">Pins</h1>
        <div className="flex gap-2">
          <Button asChild variant="outline">
            <Link to="/pins/bulk">
              <Layers />
              Bulk input
            </Link>
          </Button>
          <Button asChild>
            <Link to="/pins/new">
              <Plus />
              New pin
            </Link>
          </Button>
        </div>
      </header>

      <div className="flex w-fit gap-1 rounded-md bg-muted p-1">
        {TABS.map(([id, label]) => (
          <button
            key={id}
            onClick={() => pilih(id)}
            className={cn(
              'rounded px-4 py-1.5 text-sm transition-colors',
              tab === id ? 'bg-background font-medium shadow-sm' : 'text-muted-foreground',
            )}
          >
            {label}
          </button>
        ))}
      </div>

      {/* Panel yang tidak aktif dilepas, bukan disembunyikan — keduanya memuat
          datanya sendiri dan tidak perlu ikut menyegarkan saat tak terlihat. */}
      {tab === 'queue' ? <QueuePanel /> : <PublishedPanel />}
    </div>
  )
}
